import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addProductMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addProductMaster = createAsyncThunk('addProductMaster', async (payload) => {
  return await addProductMasterApi(payload);
});

const addProductMasterSlice = createSlice({
  name: 'addProductMaster', // Unique Name
  initialState,
  reducers: {
    addProductMasterReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addProductMaster.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addProductMaster.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addProductMaster.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addProductMasterReset } = addProductMasterSlice.actions;

export default addProductMasterSlice.reducer;
